// extracted by mini-css-extract-plugin
export var form = "styles-module--form--23I7k";
export var field = "styles-module--field--2WNpK";
export var splitLeft = "styles-module--split-left--28Tx1";
export var splitRight = "styles-module--split-right--j4qR7";
export var label = "styles-module--label--3T8NS";
export var formButton = "styles-module--formButton--2hc8g";
export var fieldError = "styles-module--fieldError--387Sz";
export var active = "styles-module--active--1qsil";